import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { UpdateTemporaryCardListing } from './Pages';

export const UpdateTemporaryCardRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={UpdateTemporaryCardListing} />
    </Fragment>
)